import { isTime, toMin, toTime } from './scheduleTimes';
import { retime, cleanParallel } from './scheduleTimeline';

// Existing explicit starts are manual unless a new save marks them as computed.
export const displayEntries = entries => {
  let cursor = '08:00';
  return entries.map(e => {
    const start = isTime(e.start) ? e.start : cursor;
    cursor = toTime(toMin(start) + (e.durationMin || 0));
    return { ...e, start };
  });
};

export const arrangeEntries = (entries, recalculate, original = entries) => {
  const previous = new Map(original.map(e => [e.id, e]));
  const displayed = new Map(displayEntries(original).map(e => [e.id, e.start]));
  const prepared = entries.map(e => {
    const raw = previous.get(e.id) || e;
    return { ...e, start: displayed.get(e.id) || e.start, manualTime: raw.manualTime ?? isTime(raw.start) };
  });
  if (!recalculate) return displayEntries(prepared);
  const start = displayEntries(original)[0]?.start || '08:00';
  return retime(cleanParallel(prepared), start).map(e=>({...e,locked:e.locked||false}));
};

export const measuredTotal = scenes => scenes.every(s => Number.isInteger(s.eighths))
  ? scenes.reduce((n, s) => n + s.eighths, 0) : null;

export const moveSelected = (source, target, ids) => ({
  source: source.filter(e => !ids.includes(e.id)),
  target: [...target, ...source.filter(e => ids.includes(e.id))],
});